import React, { useEffect, useState } from "react";
import MapTopBar from "../../components/hud/MapTopBar";
import { Outlet, useLocation } from "react-router-dom";
import MapBottomBar from "../../components/hud/MapBottomBar";
import { useAuth, useUserData } from "./hooks";
import DrawerMenu from "./components/DrawerMenu";
import ArenaDashboard from "./components/ArenaDashboard";
import { Provider } from "react-redux";
import { myStore } from "../../redux/store";
import SettingsDialog from "./components/SettingsDialog";
import IconBoard from "../../components/IconBoard";
import ArenaTour from "../../components/Tour/ArenaTour";
import Popups from "../../components/Popups";

const MapLayout = () => {
  const { logout, initAuth } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const { userInfo, getMe } = useUserData();
  const location = useLocation();
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  const [isOpenSettings, setIsOpenSettings] = useState(false);
  const closeSettings = () => {
    setIsOpenSettings(false);
    window.history.pushState({}, "", `${location.pathname}${location.search}`);
  };
  useEffect(() => {
    setIsOpenSettings(location.hash?.includes("settings"));
  }, [location.hash]);

  useEffect(() => {
    getMe();
  }, []);

  // While a map HUD screen is mounted, hide the legacy left-edge chat tab
  // (the bottom-bar chat bar is the opener here).
  useEffect(() => {
    document.body.classList.add("map-hud-mode");
    return () => document.body.classList.remove("map-hud-mode");
  }, []);

  return (
    <>
      <div>
        <MapTopBar handleLogout={logout} toggleDrawer={toggleDrawer} />
        <IconBoard />
        <Provider store={myStore}>
          <Outlet />
        </Provider>
      </div>

      {/* Other components */}
      <Popups />

      {/* Arena Tour */}


      <MapBottomBar />
      <DrawerMenu
        isOpen={isOpen}
        onClose={toggleDrawer}
        userInfo={userInfo}
        handleLogout={logout}
      />
      <SettingsDialog
        onClose={() => {
          closeSettings();
        }}
        open={isOpenSettings}
      />
      <ArenaDashboard />
    </>
  );
};

export default MapLayout;
